// src/lib/licencjaWyboru.js
// Wybrana licencja decyduje o tym, z jakiej puli lecą pytania w pojedynku.
//
// Trzymamy ją w localStorage, a nie w kontekście Reacta, bo odczytuje ją także
// inline'owy skrypt w public/index.html - ten startuje zapytanie o pytania
// jeszcze zanim aplikacja się uruchomi i musi znać wybór z poprzedniej wizyty.

import { LICENCJE, LICENCJA_PO_SLUGU } from '../data/licencje';

export const KLUCZ = 'pilotuje_licencja';
export const DOMYSLNA = 'ppl-a';

/** Slug wybranej licencji; przy braku lub nieznanej wartości - domyślna. */
export const wybranaLicencja = () => {
  if (typeof window === 'undefined') return DOMYSLNA;
  try {
    const zapisana = window.localStorage.getItem(KLUCZ);
    return LICENCJA_PO_SLUGU[zapisana] ? zapisana : DOMYSLNA;
  } catch (e) {
    // prywatne okno albo zablokowane localStorage - działamy na domyślnej
    return DOMYSLNA;
  }
};

export const zapiszLicencje = slug => {
  if (typeof window === 'undefined' || !LICENCJA_PO_SLUGU[slug]) return;
  try {
    window.localStorage.setItem(KLUCZ, slug);
  } catch (e) {
    /* brak localStorage nie może wywracać wyboru licencji */
  }
};

/** Licencje w kolejności do pokazania w przełączniku nad areną. */
export const LICENCJE_DO_WYBORU = LICENCJE.map(l => ({ slug: l.slug, nazwa: l.nazwa }));
